import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinnavimumbai() {



  const cardData = {




keyword: "Cab Service in Navi Mumbai",

headingDescription: "Garud Cab Service provides comfortable and reliable Cab Service in Navi Mumbai for families, corporate travelers, tourists, students, senior citizens, and groups looking for convenient local and outstation transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for local travel, airport transfers, railway station pickups, corporate transportation, sightseeing, one-way journeys, round trips, and customized outstation travel. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes travel across Navi Mumbai smooth and convenient. Travelers can also arrange transportation to business hubs, residential areas, shopping destinations, tourist attractions, nearby cities, and popular outstation routes according to their preferred schedule.",

topPlaces: [
  {
    title: "Vashi",
    description: "Vashi is a major commercial and residential hub of Navi Mumbai with shopping centers, offices, hotels, restaurants, and excellent transportation connectivity. Customers can book a private cab for local travel, business meetings, airport transfers, railway station trips, or outstation journeys. Garud Cab Service provides comfortable vehicles with flexible pickup and drop arrangements across Vashi."
  },
  {
    title: "Kharghar",
    description: "Kharghar is a well-developed Navi Mumbai locality known for residential communities, educational institutions, business establishments, and green surroundings. Families and professionals frequently require reliable transportation for daily and occasional travel. Customers can choose Sedan, SUV, Ertiga, Innova, or Innova Crysta for comfortable local and outstation journeys."
  },
  {
    title: "Belapur",
    description: "Belapur is an important business and administrative center of Navi Mumbai with corporate offices, government establishments, hotels, and residential developments. Travelers can book cabs for office visits, airport transfers, railway station travel, family trips, and intercity journeys. Garud Cab Service offers professional chauffeur-driven transportation with flexible schedules."
  },
  {
    title: "Panvel",
    description: "Panvel is a major transportation hub connecting Navi Mumbai with Mumbai, Pune, and several destinations across Maharashtra. It is suitable for customers planning both local travel and longer outstation journeys. Garud Cab Service provides private cabs for airport transfers, business travel, family trips, and one-way or round-trip bookings from Panvel."
  },
  {
    title: "Nerul",
    description: "Nerul is a popular residential and commercial locality with railway connectivity, educational institutions, shopping areas, and family-oriented neighborhoods. Customers can arrange comfortable cabs for local transportation, airport pickups, railway station transfers, and outstation travel. Professional chauffeurs and flexible pickup timings make travel from Nerul convenient."
  },
  {
    title: "Airoli",
    description: "Airoli is a growing IT and corporate destination in Navi Mumbai with technology companies, business parks, residential projects, and commercial establishments. Corporate professionals often require dependable transportation for meetings and office travel. Customers can book chauffeur-driven cabs for local business transportation, airport transfers, and outstation trips."
  },
  {
    title: "Ghansoli",
    description: "Ghansoli is a developing business and residential area known for corporate offices, technology companies, modern housing communities, and convenient road connectivity. Travelers can use private cabs for office visits, family travel, airport transportation, and longer journeys outside Navi Mumbai. Garud Cab Service offers suitable vehicles based on passenger and luggage requirements."
  },
  {
    title: "Ulwe",
    description: "Ulwe is a rapidly developing locality near Navi Mumbai Airport with expanding residential and commercial infrastructure. Customers frequently need reliable transportation for airport transfers, local travel, railway station connections, and trips toward Mumbai or nearby destinations. Garud Cab Service provides flexible cab bookings with convenient pickup and drop services."
  },
  {
    title: "Juinagar",
    description: "Juinagar is a well-connected Navi Mumbai locality offering access to residential areas, railway services, commercial establishments, and nearby business districts. Customers can book cabs for daily transportation, family visits, airport transfers, and outstation journeys. Garud Cab Service provides comfortable vehicles and professional drivers for flexible travel requirements."
  },
  {
    title: "Turbhe",
    description: "Turbhe is an important commercial and industrial area of Navi Mumbai with markets, warehouses, business establishments, and transportation facilities. It is useful for customers traveling for business, logistics, and commercial purposes. Garud Cab Service offers reliable chauffeur-driven cabs for local movement, airport transfers, railway station travel, and customized outstation journeys."
  }
],





"services": [
{
"name": "Cab Service in Airoli",
"description": "Book Cab Service in Airoli for convenient local and outstation transportation with professional chauffeurs and comfortable AC vehicles. The service is suitable for office travel, family journeys, airport transfers, business trips, and personal transportation requirements."
},
{
"name": "Cab Hire in Navi Mumbai",
"description": "Choose Cab Hire in Navi Mumbai for flexible private transportation with suitable vehicle options for local and long-distance travel. Sedan, SUV, Innova, and premium cars can be arranged for families, corporate passengers, tourists, and individuals."
},
{
"name": "Cabs in Navi Mumbai",
"description": "Book Cabs in Navi Mumbai for comfortable transportation across Navi Mumbai and nearby destinations. Chauffeur-driven vehicles can be arranged for city travel, airport transfers, outstation journeys, business requirements, sightseeing, and family trips."
},
{
"name": "Cabs Navi Mumbai",
"description": "Choose Cabs Navi Mumbai for convenient private transportation with flexible pickup and drop arrangements. Different vehicle categories are available for individuals, families, corporate travelers, tourists, and passengers planning local or intercity journeys."
},
{
"name": "Navi Mumbai Taxi Service",
"description": "Book Navi Mumbai Taxi Service for reliable local and outstation transportation with professional drivers and well-maintained vehicles. The service is suitable for airport transfers, office travel, family trips, sightseeing, business travel, and personal journeys."
},
{
"name": "Taxi Service in Vashi Navi Mumbai",
"description": "Choose Taxi Service in Vashi Navi Mumbai for convenient transportation within Vashi and to nearby destinations. Comfortable AC taxis can be arranged for local travel, airport transfers, corporate trips, family journeys, and outstation transportation."
},
{
"name": "Cab Service in Navi Mumbai",
"description": "Book Cab Service in Navi Mumbai for comfortable chauffeur-driven transportation across the city and beyond. The service is suitable for local commuting, airport transfers, business travel, family trips, sightseeing, and long-distance outstation journeys."
},
{
"name": "Taxi Service in Navi Mumbai",
"description": "Choose Taxi Service in Navi Mumbai for convenient private transportation with flexible pickup and drop options. Sedan, SUV, Innova, and other suitable vehicles can be arranged according to passenger count, luggage, destination, and travel requirements."
},
{
"name": "Taxi in Navi Mumbai",
"description": "Book Taxi in Navi Mumbai for practical transportation across Navi Mumbai with professional chauffeur assistance. The service can be arranged for local trips, airport transfers, business meetings, family travel, shopping, sightseeing, and outstation journeys."
},
{
"name": "Navi Mumbai Cab Service",
"description": "Choose Navi Mumbai Cab Service for reliable transportation with comfortable AC vehicles and experienced drivers. Customers can arrange local, airport, one-way, round-trip, corporate, and outstation travel according to their preferred schedule."
},
{
"name": "Navi Mumbai Taxi Service",
"description": "Book Navi Mumbai Taxi Service for convenient private travel across Navi Mumbai and surrounding destinations. Suitable vehicle categories can be selected for individuals, families, business travelers, tourists, and groups requiring comfortable chauffeur-driven transportation."
},
{
"name": "Cab Booking in Navi Mumbai",
"description": "Make Cab Booking in Navi Mumbai for scheduled private transportation with convenient pickup arrangements. Customers can select vehicle categories and plan local trips, airport transfers, corporate journeys, family travel, sightseeing, and outstation transportation."
},
{
"name": "Taxi Booking Navi Mumbai",
"description": "Choose Taxi Booking Navi Mumbai for convenient advance travel arrangements with professional chauffeur service. The service is suitable for city travel, airport transfers, business trips, family journeys, sightseeing, and long-distance transportation."
},
{
"name": "Best Cab Service in Navi Mumbai",
"description": "Choose the Best Cab Service in Navi Mumbai for comfortable private transportation supported by professional chauffeurs and well-maintained vehicles. The service is suitable for local travel, airport transfers, corporate journeys, family trips, and outstation travel."
},
{
"name": "Cheap Cab Service in Navi Mumbai",
"description": "Book Cheap Cab Service in Navi Mumbai for economical private transportation with practical vehicle options. The service is suitable for students, individuals, families, office travelers, tourists, and passengers looking for budget-conscious local or outstation travel."
},
{
"name": "Affordable Taxi Service Navi Mumbai",
"description": "Choose Affordable Taxi Service Navi Mumbai for practical transportation with suitable vehicle choices for different journey requirements. Customers can arrange comfortable taxis for local travel, airport transfers, business trips, family journeys, and outstation routes."
},
{
"name": "24x7 Cab Service in Navi Mumbai",
"description": "Book 24x7 Cab Service in Navi Mumbai for transportation at different hours of the day and night. The service is suitable for early airport transfers, late-night travel, business requirements, emergency journeys, family trips, and scheduled outstation transportation."
},
{
"name": "Cab Service Near Me Navi Mumbai",
"description": "Choose Cab Service Near Me Navi Mumbai for convenient local transportation with flexible pickup and drop arrangements. Professional chauffeur-driven vehicles can be arranged for nearby destinations, airport travel, business meetings, family trips, and personal journeys."
},
{
"name": "Airport Cab Service Navi Mumbai",
"description": "Book Airport Cab Service Navi Mumbai for comfortable transportation to and from Mumbai and Navi Mumbai airport locations. Sedan, SUV, Innova, and premium options can be arranged according to flight timing, passenger count, luggage, and destination."
},
{
"name": "Outstation Cab Service Navi Mumbai",
"description": "Choose Outstation Cab Service Navi Mumbai for comfortable long-distance transportation to destinations across Maharashtra and nearby states. Private chauffeur-driven cars can be arranged for one-way trips, round trips, family journeys, business travel, and sightseeing."
},
{
"name": "One Way Cab Navi Mumbai",
"description": "Book One Way Cab Navi Mumbai for convenient point-to-point transportation without requiring a return journey. The service is suitable for relocation, airport transfers, business travel, family visits, personal trips, and intercity travel."
},
{
"name": "Round Trip Taxi Navi Mumbai",
"description": "Choose Round Trip Taxi Navi Mumbai for convenient travel with return transportation included in the journey plan. The service is suitable for family trips, business visits, sightseeing, pilgrimage travel, and passengers planning scheduled return journeys."
},
{
"name": "Corporate Cab Service Navi Mumbai",
"description": "Book Corporate Cab Service Navi Mumbai for professional transportation for employees, meetings, client visits, office transfers, and business travel. Comfortable sedan, SUV, and premium vehicles can be arranged according to corporate travel requirements."
},
{
"name": "Wedding Cab Service Navi Mumbai",
"description": "Choose Wedding Cab Service Navi Mumbai for comfortable transportation for wedding guests, family members, and event-related travel. Suitable vehicles can be arranged for guest transfers, venue transportation, airport pickups, hotel transfers, and related journeys."
},
{
"name": "Cab Service in Vashi",
"description": "Book Cab Service in Vashi for convenient local and outstation transportation with professional chauffeurs. The service is suitable for office travel, airport transfers, family journeys, business meetings, sightseeing, and intercity travel from Vashi."
},
{
"name": "Cab Service in Nerul",
"description": "Choose Cab Service in Nerul for comfortable private transportation within Navi Mumbai and to nearby destinations. Sedan, SUV, and larger vehicle options can be arranged for airport transfers, family trips, corporate travel, and outstation journeys."
},
{
"name": "Cab Service in Belapur",
"description": "Book Cab Service in Belapur for reliable transportation with convenient pickup and drop arrangements. The service is suitable for local travel, business meetings, airport transfers, family trips, sightseeing, and long-distance outstation journeys."
},
{
"name": "Cab Service in Kharghar",
"description": "Choose Cab Service in Kharghar for comfortable chauffeur-driven transportation across Navi Mumbai and beyond. Suitable cars can be arranged for local commuting, airport transfers, corporate travel, family journeys, tourism, and outstation travel."
},
{
"name": "Cab Service in Panvel",
"description": "Book Cab Service in Panvel for convenient local and intercity transportation with professional drivers. The service is suitable for airport transfers, business travel, family trips, sightseeing, railway station transfers, and outstation journeys."
},
{
"name": "Cab Service in Airoli",
"description": "Choose Cab Service in Airoli for comfortable transportation within Airoli and to nearby Mumbai and Navi Mumbai destinations. The service can be arranged for office travel, airport transfers, family journeys, corporate requirements, and outstation trips."
},
{
"name": "Cab Service in Ghansoli",
"description": "Book Cab Service in Ghansoli for convenient private transportation with flexible pickup and destination options. Comfortable vehicles can be arranged for local trips, airport transfers, corporate travel, family journeys, sightseeing, and outstation travel."
},
{
"name": "Cab Service in Kopar Khairane",
"description": "Choose Cab Service in Kopar Khairane for reliable transportation across Navi Mumbai and nearby destinations. The service is suitable for office travel, airport transfers, business meetings, family trips, sightseeing, and long-distance private journeys."
},
{
"name": "Cab Service in Sanpada",
"description": "Book Cab Service in Sanpada for comfortable local and outstation transportation with professional chauffeur assistance. Sedan, SUV, Innova, and other vehicle options can be arranged according to passenger count, luggage, destination, and travel needs."
},
{
"name": "Navi Mumbai to Pune Cab",
"description": "Choose Navi Mumbai to Pune Cab for comfortable intercity transportation with direct pickup and destination drop. The service is suitable for families, corporate travelers, students, tourists, and individuals requiring private travel between Navi Mumbai and Pune."
},
{
"name": "Navi Mumbai to Mumbai Airport Cab",
"description": "Book Navi Mumbai to Mumbai Airport Cab for convenient airport transportation from Navi Mumbai to Mumbai Airport. Professional chauffeurs and comfortable AC vehicles can be arranged according to flight timing, passenger count, luggage, and preferred pickup location."
},
{
"name": "Navi Mumbai to Nashik Cab",
"description": "Choose Navi Mumbai to Nashik Cab for comfortable long-distance transportation between Navi Mumbai and Nashik. The service is suitable for families, business travelers, tourists, pilgrimage travelers, and passengers planning a private intercity road journey."
},
{
"name": "Navi Mumbai to Lonavala Cab",
"description": "Book Navi Mumbai to Lonavala Cab for convenient private transportation to the popular hill destination. The service is suitable for families, couples, tourists, weekend travelers, and groups seeking comfortable chauffeur-driven road travel."
},
{
"name": "Navi Mumbai to Shirdi Cab",
"description": "Choose Navi Mumbai to Shirdi Cab for comfortable private transportation for pilgrimage and family travel. Suitable vehicles can be arranged for devotees, senior passengers, families, and groups planning a convenient journey to Shirdi."
},
{
"name": "Navi Mumbai to Goa Cab",
"description": "Book Navi Mumbai to Goa Cab for comfortable long-distance private transportation with professional chauffeurs. The service is suitable for families, couples, groups, tourists, and corporate travelers planning a road trip from Navi Mumbai to Goa."
}
],
"tableData": [
["Cab Service in Airoli", "Cab Hire in Navi Mumbai"],
["Cabs in Navi Mumbai", "Cabs Navi Mumbai"],
["Navi Mumbai Taxi Service", "Taxi Service in Vashi Navi Mumbai"],
["Cab Service in Navi Mumbai", "Taxi Service in Navi Mumbai"],
["Taxi in Navi Mumbai", "Navi Mumbai Cab Service"],
["Navi Mumbai Taxi Service", "Cab Booking in Navi Mumbai"],
["Taxi Booking Navi Mumbai", "Best Cab Service in Navi Mumbai"],
["Cheap Cab Service in Navi Mumbai", "Affordable Taxi Service Navi Mumbai"],
["24x7 Cab Service in Navi Mumbai", "Cab Service Near Me Navi Mumbai"],
["Airport Cab Service Navi Mumbai", "Outstation Cab Service Navi Mumbai"],
["One Way Cab Navi Mumbai", "Round Trip Taxi Navi Mumbai"],
["Corporate Cab Service Navi Mumbai", "Wedding Cab Service Navi Mumbai"],
["Cab Service in Vashi", "Cab Service in Nerul"],
["Cab Service in Belapur", "Cab Service in Kharghar"],
["Cab Service in Panvel", "Cab Service in Airoli"],
["Cab Service in Ghansoli", "Cab Service in Kopar Khairane"],
["Cab Service in Sanpada", "Navi Mumbai to Pune Cab"],
["Navi Mumbai to Mumbai Airport Cab", "Navi Mumbai to Nashik Cab"],
["Navi Mumbai to Lonavala Cab", "Navi Mumbai to Shirdi Cab"],
["Navi Mumbai to Goa Cab", "Navi Mumbai Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Cab Service in Navi Mumbai for Local & Outstation Travel",
    WhyChoosedescription: "A private cab provides a convenient transportation option across Navi Mumbai for airport transfers, local travel, business trips, family outings, railway station transfers, and journeys to nearby or outstation destinations."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Location",
    WhyChoosedescription: "Passengers can arrange pickup from their home, hotel, office, residential society, railway station area, business location, or another accessible point across Navi Mumbai."
  },
  {
    WhyChooseheading: "Comfortable Cars for Different Travel Needs",
    WhyChoosedescription: "Families, couples, professionals, and groups can select a suitable vehicle based on passenger count, luggage requirements, trip duration, and preferred level of comfort."
  },
  {
    WhyChooseheading: "Convenient Airport & Railway Transfers",
    WhyChoosedescription: "Private cabs can be arranged for travel to and from Navi Mumbai Airport, railway stations, and other major transport points, providing direct transportation to your chosen destination."
  },
  {
    WhyChooseheading: "Useful for Corporate & Business Travel",
    WhyChoosedescription: "Professionals can arrange cabs for office visits, client meetings, conferences, industrial areas, business appointments, and regular corporate transportation requirements across Navi Mumbai."
  },
  {
    WhyChooseheading: "Local Sightseeing & City Travel",
    WhyChoosedescription: "A private cab is suitable for visiting shopping areas, attractions, family destinations, hotels, restaurants, residential locations, and other places within Navi Mumbai."
  },
  {
    WhyChooseheading: "One-Way & Outstation Cab Options",
    WhyChoosedescription: "Passengers travelling outside Navi Mumbai can choose one-way or round-trip transportation for destinations such as Mumbai, Pune, Lonavala, Mahabaleshwar, Nashik, Surat, and other locations."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, luggage details, preferred vehicle, and trip type with Garud Cab Service for suitable cab booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Cab Service in Navi Mumbai?",
    answer: "Yes, Garud Cab Service provides private cab services in Navi Mumbai for local travel, airport transfers, railway station transportation, corporate trips, family outings, and outstation journeys."
  },
  {
    question: "Can I book a cab anywhere in Navi Mumbai?",
    answer: "Yes, pickup can be arranged from a preferred accessible location in Navi Mumbai, including homes, hotels, offices, residential societies, business areas, and transport points."
  },
  {
    question: "Can I book a Navi Mumbai cab for airport transfers?",
    answer: "Yes, private cabs can be arranged for airport pickup and drop requirements, including travel to or from Navi Mumbai Airport according to your schedule."
  },
  {
    question: "Can I use the cab for local Navi Mumbai travel?",
    answer: "Yes, private cabs can be used for local transportation between residential areas, offices, hotels, shopping destinations, railway stations, business locations, and other accessible places."
  },
  {
    question: "Does the service provide outstation cabs from Navi Mumbai?",
    answer: "Yes, outstation cab arrangements can be planned from Navi Mumbai for one-way and round-trip travel to destinations such as Pune, Mumbai, Lonavala, Mahabaleshwar, Nashik, Surat, and other cities."
  },
  {
    question: "Can corporate travellers book cabs in Navi Mumbai?",
    answer: "Yes, business travellers can arrange private cabs for office visits, meetings, conferences, client appointments, industrial travel, and other professional transportation requirements."
  },
  {
    question: "Is the cab service suitable for families?",
    answer: "Yes, families and groups can select a suitable vehicle according to passenger numbers, luggage requirements, and comfort preferences."
  },
  {
    question: "Can I carry luggage in the Navi Mumbai cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger luggage requirements should be communicated during booking."
  },
  {
    question: "Can I book a one-way cab from Navi Mumbai?",
    answer: "Yes, one-way cab service can be arranged for passengers travelling to their preferred destination without requiring the same vehicle for the return journey."
  },
  {
    question: "How can I book a Cab Service in Navi Mumbai?",
    answer: "Share your pickup location, destination, travel date, passenger details, luggage requirements, preferred vehicle, and local or outstation travel requirement with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Patil",
    feedback: "I needed a cab in Navi Mumbai for several business meetings and arranged a private vehicle. The flexible pickup and direct travel between locations made my work schedule easier to manage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Joshi",
    feedback: "Our family booked a cab in Navi Mumbai for local travel and an airport transfer. Having a private vehicle was convenient for everyone, especially with our luggage.",
    rating: 5
  }
];










  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Navi Mumbai",
  "image": "https://garudcabs.com/assets/images/cab-service-in-navi-mumbai.webp",
  "description": "Book Cab Service in Navi Mumbai with Garud Cab for safe, comfortable, and reliable local, airport, and outstation transportation. Get taxi and cab services across Navi Mumbai including Airoli, Vashi, and nearby areas with easy cab booking, professional drivers, and Sedan, Ertiga, SUV, Innova, and Innova Crysta options for city travel, airport transfers, business trips, family journeys, and outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/cab-service-in-navi-mumbai"
  }
};







  return (
    <div>

<Helmet>
  <title>Cab Service in Navi Mumbai | Taxi & Cab Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Cab Service in Navi Mumbai with Garud Cab for reliable local, airport, and outstation travel. Get taxi and cab services in Airoli, Vashi, and across Navi Mumbai with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Cab Service in Airoli, Cab Hire in Navi Mumbai, Cabs in Navi Mumbai, Cabs Navi Mumbai, Navi Mumbai Taxi Service, Taxi Service in Vashi Navi Mumbai, Cab Service in Navi Mumbai, Taxi Service in Navi Mumbai, Cabs in Navi Mumbai, Taxi in Navi Mumbai, Navi Mumbai Cab Service, Navi Mumbai Taxi Service, Cab Booking in Navi Mumbai, Taxi Booking in Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinnavimumbai;